import React from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Redirect, Route } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';

const PublicRoute = ({ component: Component, ...rest }) => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  return (
    <Route
      {...rest}
      render={props =>
        inProgress === InteractionStatus.None && isAuthenticated ? (
          <Redirect to="/" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
